import { render } from "./ThanksSummary.vue?vue&type=template&id=365c1d83&scoped=true&lang=true"
import script from "./ThanksSummary.vue?vue&type=script&lang=js"
export * from "./ThanksSummary.vue?vue&type=script&lang=js"

import "./ThanksSummary.vue?vue&type=style&index=0&id=365c1d83&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365c1d83"]])

export default __exports__